import React from 'react'

import { Container } from '../../../Container'

import './content-listing.css'

export const ContentListing = ({ details }) => {
    return (
        <div className='content'>
            <Container>
                <h2 className='mt-0 text-center text-white uppercase'><span style={{ borderBottom: '2px solid var(--primary-white-star)' }}>Learn More</span></h2>
                <div className='test'>
                    {details.map((item, index) => {
                        const className = (index % 5 === 0 || index % 5 === 1) ? 'twos' : 'threes';
                        return (
                        <div key={index} className={`item ${className}`}>
                            <div className='relative media'>
                                <div className='image'>
                                    <img src={item.image} className='mb-0' alt={item.name || 'Packaging Media'} />
                                </div>
                                <div className='absolute image-1'>
                                    <img src={item.image1} alt={item.name || 'Packaging Media 1'} />
                                </div>
                            </div>
                            <p className='text-center title'>{item.val}</p>
                            <p className='text-center'>{item.description}</p>
                        </div>
                        );
                    })}
                </div>
            </Container>
        </div>
    )
}